export default "__VITE_ASSET__umSR6Jr6__"